import styled from 'styled-components';
import { createGradientOrSolid } from 'utils/index';
import { Gradient } from 'utils/types';
import { breakpoints } from 'styles/breakpoints';

interface IStyledBingoPopProps {
  backgroundColor: Gradient;
  backgroundSrc?: string;
}

export const StyledLoadComplete = styled.div<IStyledBingoPopProps>`
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  width: 100%;
  height: 166px;
  position: relative;
  border-radius: 15px;
  background: ${(props: any) =>
    props.backgroundSrc
      ? `url("${props.backgroundSrc}")`
      : createGradientOrSolid(props.backgroundColor)};
  background-size: 100% 100%;
  padding: 24px 10px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  min-width: 235px;
  justify-content: space-between;

  &.load-complete-bundle {
    .emblem-badge {
      left: -12px;
      top: -8px;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    height: 249px;
    padding: 35px 10px 18px;
  }
` as any;

export const StyledLoadCompleteEmblem = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  max-height: 64px;
  max-width: 64px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: auto;
    height: 100%;
    max-height: 64px;
    object-fit: contain;
  }
`;

export const StyledLoadCompletePriceContainer = styled.div<{}>`
  position: relative;
  width: 100%;

  .timer {
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    font-size: 10px;
    font-weight: 700;
    color: #f7f495;
    border-radius: 17px;
    border: 1px solid #000;
    background: #9135f3;
    text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
      1px 1px 0 #000000;
    padding: 6px;
    width: 100%;
    max-width: 78px;
  }

  .availability {
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    font-size: 10px;
    font-weight: 700;
    color: #f7f495;
    border-radius: 17px;
    border: 1px solid #000;
    background: #9135f3;
    text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
      1px 1px 0 #000000;
    padding: 6px;
    width: 100%;
    max-width: 78px;
  }

  .price {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    position: relative;
    border: 1px solid #000;
    height: 36px;
    max-width: 132px;
    padding: 4px;
    border-radius: 16px;
    background: var(--button-bg-color);
    box-shadow: 0px -4.003px 2.002px 0px #841e9b inset,
      0px 5.004px 1.001px 0px #e156d7 inset,
      0px -7.005px 0.5px 0px #e156d7 inset,
      5.004px 0px 1.001px 0px #e156d7 inset,
      -5.004px 0px 1.001px 0px #e156d7 inset,
      0px 2.002px 2.002px 0px rgba(0, 0, 0, 0.25);

    .totalPrice {
      position: relative;
      z-index: 1;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      align-items: center;
      max-width: 100%;
      padding: 0 5px;

      .final-price {
        font-size: calc(clamp(4px, 1em * 1.5, 18px));
        text-shadow: none;
        text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
          1px 1px 0 #000000;
      }

      .isFree {
        font-size: calc(clamp(4px, 1em * 1.5, 18px));
        text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
          1px 1px 0 #000000;
      }

      .stroked {
        font-size: calc(clamp(4px, 1em * 1, 16px));
        margin-left: 4px;
        text-decoration: none;
        color: #fff;
        font-weight: 700;
        text-shadow: -1px -1px 0 #000000, 1px -1px 0 #000000, -1px 1px 0 #000000,
          1px 1px 0 #000000;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 2px;
          background-color: #ff0000;
        }
      }
    }
  }
`;
